(function () {
  function init() {
    var descEl = document.querySelector('[data-colour-description]');
    if (!descEl) return;
    var productId = descEl.dataset.productId;
    var jsonEl = document.querySelector('[data-colour-description-json="' + productId + '"]');
    if (!jsonEl) return;

    var descriptions;
    try {
      descriptions = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!descriptions || typeof descriptions !== 'object') return;

    function applyForVariantId(variantId) {
      var html = descriptions[variantId];
      if (html) {
        descEl.innerHTML = html;
      }
    }

    var initialInput = document.querySelector('input[name="id"]');
    if (initialInput && initialInput.value) {
      applyForVariantId(initialInput.value);
    }

    if (!window.MinimogEvents || typeof window.MinimogEvents.subscribe !== 'function') return;

    window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
      if (!variant) return;
      applyForVariantId(variant.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
